import { ADMIN_COURSE_MENU } from "../../../../resources/constants/adminPanel";
import { DURATION_LBL } from "../../../../resources/constants/durationType";
import { LANGUAGE_LBL } from "../../../../resources/constants/lang";
import { convertHourToDuration } from "../../../../Utils";
import { COURSE_ADMIN_POPUP_ADD_OBJECTIVE, COURSE_ADMIN_POPUP_ADD_PREREQUISITE, COURSE_ADMIN_POPUP_ADD_PUBLIC, COURSE_ADMIN_POPUP_DESCRIPTION_CHECK, COURSE_ADMIN_POPUP_EXPIRY_CHECK, COURSE_ADMIN_POPUP_OBJECTIVE_CHECK, COURSE_ADMIN_POPUP_PREREQUISITE_CHECK, COURSE_ADMIN_POPUP_PUBLIC_CHECK, COURSE_ADMIN_POPUP_RESET, COURSE_ADMIN_POPUP_SET_COURSE, COURSE_ADMIN_POPUP_SET_COURSE_ID, COURSE_ADMIN_POPUP_SET_DESCRIPTION, COURSE_ADMIN_POPUP_SET_ENABLED, COURSE_ADMIN_POPUP_SET_EXPIRY_UNIT, COURSE_ADMIN_POPUP_SET_EXPIRY_VALUE, COURSE_ADMIN_POPUP_SET_INFORMATIONS_LOADING, COURSE_ADMIN_POPUP_SET_LOADING, COURSE_ADMIN_POPUP_SET_NEW_OBJECTIVE, COURSE_ADMIN_POPUP_SET_NEW_PREREQUISITE, COURSE_ADMIN_POPUP_SET_NEW_PUBLIC, COURSE_ADMIN_POPUP_SET_OBJECTIVES, COURSE_ADMIN_POPUP_SET_PICTURE, COURSE_ADMIN_POPUP_SET_PICTURE_LOADING, COURSE_ADMIN_POPUP_SET_POPUP_TITLE, COURSE_ADMIN_POPUP_SET_PREREQUISITES, COURSE_ADMIN_POPUP_SET_PUBLICS, COURSE_ADMIN_POPUP_SET_SPECIFICATIONS_LOADING, COURSE_ADMIN_POPUP_SET_STATUS_ENABLED, COURSE_ADMIN_POPUP_SET_TITLE, COURSE_ADMIN_POPUP_SET_UNIT_COMPLETE_LOCK, COURSE_ADMIN_POPUP_TITLE_CHECK, COURSE_ADMIN_POPUP_TOGGLE_MENU_STATUS, COURSE_ADMIN_POPUP_SET_SPECIFICATION_ACTION_LOADING, COURSE_ADMIN_POPUP_DELETE_SPECIFICATION, COURSE_ADMIN_POPUP_SET_CATEGORIES_LOADING, COURSE_ADMIN_POPUP_SET_CATEGORIES, COURSE_ADMIN_POPUP_SET_CATEGORY_LOADING, COURSE_ADMIN_POPUP_ADD_CATEGORY, COURSE_ADMIN_POPUP_DELETE_CATEGORY, COURSE_ADMIN_POPUP_SET_USERS, COURSE_ADMIN_POPUP_ADD_USERS, COURSE_ADMIN_POPUP_SET_USERS_LOADING, COURSE_ADMIN_POPUP_SET_USER_LOADING, COURSE_ADMIN_POPUP_SET_USER_SEARCH_VALUE, COURSE_ADMIN_POPUP_SET_HAS_NEXT, COURSE_ADMIN_POPUP_SET_PAGING_PAGE, COURSE_ADMIN_POPUP_DELETE_USER, COURSE_ADMIN_POPUP_SET_PREVIEW_VIDEO, COURSE_ADMIN_POPUP_PREVIEW_VIDEO_CHECK, COURSE_ADMIN_POPUP_SET_STATUS, COURSE_ADMIN_POPUP_SET_ADVERTISEMENT_VISIBILITY, COURSE_ADMIN_POPUP_SET_PRICE, COURSE_ADMIN_POPUP_PRICE_CHECK, COURSE_ADMIN_POPUP_SET_SEO_KEYWORDS, COURSE_ADMIN_POPUP_SET_USER_EXPIRE_DATE, COURSE_ADMIN_POPUP_SET_USER_UNIT_COMPLETE_LOCK, COURSE_ADMIN_POPUP_SET_SEO_LOCKED, COURSE_ADMIN_POPUP_SET_LANG, COURSE_ADMIN_POPUP_SET_OTHER_LANG_ID } from "../../../actions/ActionTypes";

const defaultState = {
    popupEnabled: null,
    isLoading: false,

    menu: ADMIN_COURSE_MENU,

    courseId: null,
    popupTitle: 'Chargement',

    showAdvertisement: false,

    // Informations
    picture: null,
    title: '',
    description: '',
    previewVideo: '',
    unitCompleteLock: false,
    expiryDurationValue: '',
    expiryDurationUnit: null,
    enabled: true,
    model: false,
    status: 0,
    price: null,
    seoKeyword: [],
    locked: false,

    isTitleValid: true,
    isDescriptionValid: true,
    isPreviewVideoValid: true,
    isExpiryDurationValid: true,
    isPriceValid: true,

    isInformationsLoading: false,
    isPictureLoading: false,
    activeUsers: null,

    lang: LANGUAGE_LBL[0],
    otherLangId: null,

    // Specification
    isSpecificationsLoading: true,
    isSpecificationActionLoading: false,
    objectives: [],
    publics: [],
    prerequisites: [],

    newObjective: '',
    newPublic: '',
    newPrerequisite: '',

    isNewObjectiveValid: true,
    isNewPublicValid: true,
    isNewPrerequisiteValid: true,

    // Category
    isCategoriesLoading: true,
    categories: [],

    // User
    isUsersLoading: true,
    users: [],
    hasNext: true,
    pagingPage: 0,
    userSearchValue: ''
};

export default function appReducer(state = defaultState, action) {
    switch (action.type) {
        case COURSE_ADMIN_POPUP_RESET: {
            return defaultState;
        }
        case COURSE_ADMIN_POPUP_SET_ENABLED: {
            return { ...state, popupEnabled: action.payload.type };
        }
        case COURSE_ADMIN_POPUP_SET_POPUP_TITLE: {
            return { ...state, popupTitle: action.payload.title };
        }

        case COURSE_ADMIN_POPUP_SET_LOADING: {
            return { ...state, isLoading: action.payload.isLoading };
        }
        case COURSE_ADMIN_POPUP_SET_INFORMATIONS_LOADING: {
            return { ...state, isInformationsLoading: action.payload.isLoading };
        }
        case COURSE_ADMIN_POPUP_SET_PICTURE_LOADING: {
            return { ...state, isPictureLoading: action.payload.isLoading };
        }

        case COURSE_ADMIN_POPUP_SET_ADVERTISEMENT_VISIBILITY: {
            return { ...state, showAdvertisement: action.payload.showAdvertisement };
        }

        case COURSE_ADMIN_POPUP_TOGGLE_MENU_STATUS: {
            return {
                ...state, menu: state.menu.map(i => {
                    if (i.disabled === undefined)
                        return i;

                    i.disabled = !action.payload.enable
                    return i;
                })
            };
        }

        case COURSE_ADMIN_POPUP_SET_COURSE: {
            const { course } = action.payload;
            const duration = convertHourToDuration(course.expiryDurationHour);

            return {
                ...state,
                courseId: course.id,
                enabled: course.enabled,
                model: course.model,
                picture: course.picture,
                title: course.title,
                description: course.description,
                previewVideo: course.previewVideo,
                unitCompleteLock: course.unitCompleteLock,
                expiryDurationValue: duration.value,
                expiryDurationUnit: DURATION_LBL.filter(lbl => lbl.value === duration.type)[0],
                activeUsers: course.activeUsers,
                status: course.status,
                price: course.price,
                locked: course.locked,
                seoKeyword: course.seoKeyword?.map(k => k.label) || [],
                lang: LANGUAGE_LBL.find(l => l.value === course.lang),
                otherLangId: course.otherLangId
            };
        }
        case COURSE_ADMIN_POPUP_SET_COURSE_ID: {
            return { ...state, courseId: action.payload.courseId };
        }

        // Informations
        case COURSE_ADMIN_POPUP_SET_SPECIFICATIONS_LOADING: {
            return { ...state, isSpecificationsLoading: action.payload.isLoading };
        }
        case COURSE_ADMIN_POPUP_SET_SPECIFICATION_ACTION_LOADING: {
            return { ...state, isSpecificationActionLoading: action.payload.isLoading };
        }
        case COURSE_ADMIN_POPUP_SET_PICTURE: {
            return { ...state, picture: action.payload.picture };
        }
        case COURSE_ADMIN_POPUP_SET_TITLE: {
            return { ...state, title: action.payload.title, isTitleValid: true };
        }
        case COURSE_ADMIN_POPUP_SET_DESCRIPTION: {
            return { ...state, description: action.payload.description, isDescriptionValid: true };
        }
        case COURSE_ADMIN_POPUP_SET_PREVIEW_VIDEO: {
            return { ...state, previewVideo: action.payload.previewVideo, isPreviewVideoValid: true };
        }
        case COURSE_ADMIN_POPUP_SET_PRICE: {
            return { ...state, price: action.payload.price, isPriceValid: true };
        }
        case COURSE_ADMIN_POPUP_SET_UNIT_COMPLETE_LOCK: {
            return { ...state, unitCompleteLock: action.payload.unitCompleteLock };
        }
        case COURSE_ADMIN_POPUP_SET_EXPIRY_VALUE: {
            return { ...state, expiryDurationValue: action.payload.expiryDurationValue, isExpiryDurationValid: true };
        }
        case COURSE_ADMIN_POPUP_SET_EXPIRY_UNIT: {
            return { ...state, expiryDurationUnit: action.payload.expiryDurationUnit, isExpiryDurationValid: true };
        }
        case COURSE_ADMIN_POPUP_SET_LANG: {
            return { ...state, lang: action.payload.lang };
        }
        case COURSE_ADMIN_POPUP_SET_OTHER_LANG_ID: {
            return { ...state, otherLangId: action.payload.otherLangId };
        }
        case COURSE_ADMIN_POPUP_SET_STATUS_ENABLED: {
            return { ...state, enabled: action.payload.enabled };
        }
        case COURSE_ADMIN_POPUP_SET_STATUS: {
            return { ...state, status: action.payload.status };
        }
        case COURSE_ADMIN_POPUP_SET_SEO_KEYWORDS: {
            return { ...state, seoKeyword: action.payload.seoKeyword };
        }
        case COURSE_ADMIN_POPUP_SET_SEO_LOCKED: {
            return { ...state, locked: action.payload.locked };
        }

        // Specifications
        case COURSE_ADMIN_POPUP_SET_OBJECTIVES: {
            return { ...state, objectives: action.payload.objectives };
        }
        case COURSE_ADMIN_POPUP_SET_PUBLICS: {
            return { ...state, publics: action.payload.publics };
        }
        case COURSE_ADMIN_POPUP_SET_PREREQUISITES: {
            return { ...state, prerequisites: action.payload.prerequisites };
        }
        case COURSE_ADMIN_POPUP_ADD_OBJECTIVE: {
            return { ...state, objectives: [...state.objectives, action.payload.objective] };
        }
        case COURSE_ADMIN_POPUP_ADD_PUBLIC: {
            return { ...state, publics: [...state.publics, action.payload.public] };
        }
        case COURSE_ADMIN_POPUP_ADD_PREREQUISITE: {
            return { ...state, prerequisites: [...state.prerequisites, action.payload.prerequisite] };
        }
        case COURSE_ADMIN_POPUP_DELETE_SPECIFICATION: {
            return {
                ...state,
                objectives: state.objectives.filter(s => s.id !== action.payload.id),
                publics: state.publics.filter(s => s.id !== action.payload.id),
                prerequisites: state.prerequisites.filter(s => s.id !== action.payload.id)
            };
        }


        case COURSE_ADMIN_POPUP_SET_NEW_OBJECTIVE: {
            return { ...state, newObjective: action.payload.newObjective, isNewObjectiveValid: true };
        }
        case COURSE_ADMIN_POPUP_SET_NEW_PUBLIC: {
            return { ...state, newPublic: action.payload.newPublic, isNewPublicValid: true };
        }
        case COURSE_ADMIN_POPUP_SET_NEW_PREREQUISITE: {
            return { ...state, newPrerequisite: action.payload.newPrerequisite, isNewPrerequisiteValid: true };
        }

        // Categories
        case COURSE_ADMIN_POPUP_SET_CATEGORIES_LOADING: {
            return { ...state, isCategoriesLoading: action.payload.isLoading };
        }
        case COURSE_ADMIN_POPUP_SET_CATEGORIES: {
            return { ...state, categories: action.payload.categories };
        }
        case COURSE_ADMIN_POPUP_ADD_CATEGORY: {
            return { ...state, categories: [...state.categories, action.payload.category] };
        }
        case COURSE_ADMIN_POPUP_DELETE_CATEGORY: {
            return { ...state, categories: state.categories.filter(c => c.id !== action.payload.id) }
        }
        case COURSE_ADMIN_POPUP_SET_CATEGORY_LOADING: {
            return {
                ...state, categories: state.categories.map(c => {
                    if (c.id !== action.payload.id)
                        return c;

                    return { ...c, isLoading: action.payload.isLoading };
                })
            };
        }

        // Users
        case COURSE_ADMIN_POPUP_SET_USERS_LOADING: {
            return { ...state, isUsersLoading: action.payload.isLoading };
        }
        case COURSE_ADMIN_POPUP_SET_USER_LOADING: {
            return {
                ...state, users: state.users.map(u => {
                    if (u.userCourseId !== action.payload.id)
                        return u;

                    return { ...u, isLoading: action.payload.isLoading };
                })
            }
        }
        case COURSE_ADMIN_POPUP_SET_USER_EXPIRE_DATE: {
            return {
                ...state, users: state.users.map(u => {
                    if (u.userCourseId !== action.payload.id)
                        return u;

                    return { ...u, user: { ...u.user, expireDate: action.payload.date } };
                })
            }
        }
        case COURSE_ADMIN_POPUP_SET_USER_UNIT_COMPLETE_LOCK: {
            return {
                ...state, users: state.users.map(u => {
                    if (u.userCourseId !== action.payload.id)
                        return u;

                    return { ...u, user: { ...u.user, unitCompleteLock: action.payload.unitCompleteLock } };
                })
            }
        }
        case COURSE_ADMIN_POPUP_SET_USERS: {
            return { ...state, users: action.payload.users };
        }
        case COURSE_ADMIN_POPUP_ADD_USERS: {
            return { ...state, users: state.users.concat(action.payload.users) };
        }
        case COURSE_ADMIN_POPUP_DELETE_USER: {
            return { ...state, users: state.users.filter(u => u.userCourseId !== action.payload.id) };
        }
        case COURSE_ADMIN_POPUP_SET_USER_SEARCH_VALUE: {
            return { ...state, userSearchValue: action.payload.userSearchValue };
        }
        case COURSE_ADMIN_POPUP_SET_HAS_NEXT: {
            return { ...state, hasNext: action.payload.hasNext };
        }
        case COURSE_ADMIN_POPUP_SET_PAGING_PAGE: {
            return { ...state, pagingPage: action.payload.pagingPage };
        }

        // Check
        case COURSE_ADMIN_POPUP_TITLE_CHECK: {
            return { ...state, isTitleValid: action.payload.isValid };
        }
        case COURSE_ADMIN_POPUP_DESCRIPTION_CHECK: {
            return { ...state, isDescriptionValid: action.payload.isValid };
        }
        case COURSE_ADMIN_POPUP_PREVIEW_VIDEO_CHECK: {
            return { ...state, isPreviewVideoValid: action.payload.isValid };
        }
        case COURSE_ADMIN_POPUP_EXPIRY_CHECK: {
            return { ...state, isExpiryDurationValid: action.payload.isValid };
        }
        case COURSE_ADMIN_POPUP_PRICE_CHECK: {
            return { ...state, isPriceValid: action.payload.isValid };
        }

        case COURSE_ADMIN_POPUP_OBJECTIVE_CHECK: {
            return { ...state, isNewObjectiveValid: action.payload.isValid };
        }
        case COURSE_ADMIN_POPUP_PUBLIC_CHECK: {
            return { ...state, isNewPublicValid: action.payload.isValid };
        }
        case COURSE_ADMIN_POPUP_PREREQUISITE_CHECK: {
            return { ...state, isNewPrerequisiteValid: action.payload.isValid };
        }

        default:
            return state;
    }
}